import { render, staticRenderFns } from "./ListaCitasview.vue?vue&type=template&id=571dfa94&scoped=true"
import script from "./ListaCitasview.vue?vue&type=script&lang=js"
export * from "./ListaCitasview.vue?vue&type=script&lang=js"
import style0 from "./ListaCitasview.vue?vue&type=style&index=0&id=571dfa94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dfa94",
  null
  
)

export default component.exports